import styled from 'styled-components';
import { colors, wrapper } from 'globalStyles';
import { media } from 'utils/style-utils';

export const Wrapper = styled.div`
  .channels-page__content {
    ${wrapper}
    height: 100%;
    font-size: 16px;
    font-weight: bold;
    line-height: 20px;
    color: ${colors.MEDIUM_GRAY};
    margin: 0px auto;
    position: relative;
    
    .table-wrapper {
      padding-bottom: 200px;
      ${media.mobile_plus`padding-bottom: 0px;`
    }
      table {
        tbody {
            td {
           width: 30%;

          &:nth-child(1) {
            
          }
          &:nth-child(1) {
            width: 30%;
            max-width: 200px;
          }
          &:nth-child(3) {
            width: 16%;
          }
          &:last-child {
            padding-right: 10px;
            width: 5%;
            }
          }
        }
      }
    } 
  }

  .channel-page__fetching-wrapper {
    margin-top: 100px;
  }

  .channel-page-forms__form-title {
    margin: auto 0;
  }

  .channel-forms__checkbox {
    width: 100%;
    line-height: 20px;
    font-size: 12px;
    font-weight: normal;
    color: ${colors.LIGHT_GRAY};
  }

  .channel-forms__checkbox-input {
    display: none;
  }

  .channel-forms__checkbox-indicator:hover {
    cursor: pointer;
  }

  .channel-forms__checkbox-text {
    line-height: 20px;
    cursor: pointer;
    color: #183748;
    margin: 38px 0px;
  }

  .channel-forms__checkbox-indicator {
    float: left;
    width: 20px;
    height: 20px;
    border: solid 1px ${colors.LIGHT_GRAY};
    border-radius: 3px;
    transition: .1s;
    margin: 0 20px 20px 20px;
  }

  .channel-forms__checkbox-input:checked + .channel-forms__checkbox-indicator {
    background-color: ${colors.LIGHT_GREEN};
    border: solid 1px ${colors.LIGHT_GREEN};
  }

  .channel-forms__checkbox-input:checked + .channel-forms__checkbox-indicator:before {
    content: '';
    display: block;
    position: relative;
    left: 6px;
    width: 4px;
    height: 12px;
    border: solid ${colors.WHITE};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }

  .channel-forms__checkbox-input ~ div{
    display: none;
  }

  .display_none{
    display: none;
  }

  .display_block{
    display: block;
  }

  .channel-forms__password-input ~ div{
    display: none;
  }
  .channel-forms__checkbox-input:checked ~ div {
    display: block;
    margin-top: 38px;
  }

  .channel-forms__group {
    text-align: right;
    > button {
      max-width: 150px;
      width: 100%;
      height: 40px;
      padding: 5px;
      ${ media.mobile`
          margin-top: 20px;
      `}
    }
  }

  .channel-forms__static-url {
    font-weight: 300;
    font-size: 12px;
    line-height: 24px;
    color: ${colors.BODY};
    position: absolute;
    padding: 0 20px;
  }

  .channel-forms__channel-url-input {
    padding: 0 0 0 100px !important;
  }

  .channel-forms__theme-form-wrapper {
    margin: auto;
    display: flex;

    ${ media.mobile_and_tablet`
      flex-wrap: wrap;
      justify-content: center;
      align-items:  center;
    `}

    ${ media.desktop`
      flex-wrap: wrap;
      justify-content: center;
      align-items:  center;
    `}
  }

  .channel-forms__theme-fields {
    width: 100%;
    margin: 45px 0 0 80px;

    ${ media.mobile_and_tablet`
      margin: 0px;
      margin-top: 40px;
    `}

    ${ media.desktop`
      margin: 0px;
      margin-top: 40px;
    `}
  }

  .channel-file-field__children {
    font-size: 11px;
    line-height: 16px;
    font-weight: normal;
  }

  .channel-file-field__info {
    color: ${colors.BODY};
    margin: 16px 0 10px;
  }

  .channel-file-field__instructions {
    color: ${colors.MEDIUM_GRAY};
    margin: 0;
  }

  .channel-forms__photo-options {

    .column {
          width: 50%;
          display: flex;
          justify-content: center;
      }
  }

  .channel-forms__filter-field-option {
    width: calc(100% - 40px);
    margin: 0px auto;
  }
  .SingleDatePicker__picker
  {
    .CalendarMonth__caption{
        padding: 15px 0 50px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/containers/ChannelsPage/styledComponents.js